import { render, staticRenderFns } from "./AddInstitutionModal.vue?vue&type=template&id=a476ecfe&"
import script from "./AddInstitutionModal.vue?vue&type=script&lang=js&"
export * from "./AddInstitutionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports